import { APP_ERROR, TOGGLE_APP_ERROR_VISIBILITY, CLEAR_ALL_ERRORS } from './constants';

const createAppError = (errorType, error) => ({
  type: APP_ERROR,
  id: Date.now().toString(),
  error,
  errorType,
  visible: true,
});

const toggleAppErrorVisibility = (id) => ({
  type: TOGGLE_APP_ERROR_VISIBILITY,
  id,
});

const clearAllErrors = () => ({
  type: CLEAR_ALL_ERRORS,
});

export {
  createAppError,
  toggleAppErrorVisibility,
  clearAllErrors,
};



// WEBPACK FOOTER //
// ./src/containers/App/actions.js